// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8668 ? "2683d4ff" : chunkId) + "." + {"24":"23a0be898578f674","169":"195c787d8c0e2633","341":"5d63e515ad18a84a","2722":"4b81949b810151c9","7674":"864dfb7f11afdc70","8456":"81ac4abc87832941","8668":"329e495858d739f7"}[chunkId] + ".js";
};